import { performRESTRequest } from "@ng-mw/framework-core"
import { GetCampaignsByTagResponse, CampaignDetails } from "../types/CampaignAdminTypes"
import { sortCampaignDetailsByFromDateAndCampaignId } from "../helpers/sortCampaignDetailsByFromDateAndCampaignId"
import { mapGetProductsByCampaignIdResponseToCampaignDetails } from "../helpers/mapGetProductsByCampaignIdResponseToCampaignDetails"

/**
 * Retrieves the details of a single campaign based on the storeId and campaignAdminTag.
 *
 * @param {string} storeId - The ID of the store (Example: 7080001271961).
 * @param {string} campaignAdminTag - The unique tag identifying the campaign (Example: app_bundle_1).
 *
 * @returns {Promise<CampaignDetails>} A promise that resolves to the campaign details object.
 */
export const getSingleCampaignByTag = async (
    storeId: string,
    campaignAdminTag: string,
): Promise<CampaignDetails | undefined> => {
    const params = new URLSearchParams({
        page: "1",
        page_size: "20",
        full_response: "true",
        tags: campaignAdminTag,
    })

    const response = await performRESTRequest({
        method: "GET",
        path: `/api/products/{chainid}/${storeId}/campaigns?${params.toString()}`,
    })

    if (!Array.isArray(response?.hits?.hits)) {
        throw new TypeError(
            "Malformed response from REST: Missing required array as hits property.",
        )
    }

    const responseTyped = response as GetCampaignsByTagResponse

    if (responseTyped.hits.hits.length === 0) {
        // Just return early if no results
        return undefined
    }

    const campaignDetails = mapGetProductsByCampaignIdResponseToCampaignDetails(responseTyped)

    const sortedCampaignDetails = sortCampaignDetailsByFromDateAndCampaignId(campaignDetails)

    const campaignDetail = sortedCampaignDetails[0]

    if (!campaignDetail) {
        throw new Error("Missing CampaignDetail at index 0.")
    }

    return campaignDetail
}
